__turbopack_context__.v({
  "active": "mWYG2a_active",
  "category": "mWYG2a_category",
  "categoryLink": "mWYG2a_categoryLink",
  "categoryLinkActive": "mWYG2a_categoryLinkActive",
  "desktop": "mWYG2a_desktop",
  "icon": "mWYG2a_icon",
});
